import { CdkTrapFocus } from '@angular/cdk/a11y';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';

/**
 * Pannello laterale sotto i 1024 px (FR-028): fuoco intrappolato finché è aperto, chiusura
 * con Esc o toccando fuori, e il fuoco torna al comando che l'ha aperto.
 */
@Component({
  selector: 'bs-mobile-drawer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkTrapFocus],
  template: `
    @if (open()) {
      <div class="fixed inset-0 z-40 lg:hidden">
        <div
          class="absolute inset-0 bg-stone-950/50"
          aria-hidden="true"
          data-testid="drawer-backdrop"
          (click)="closed.emit()"
        ></div>
        <div
          id="mobile-drawer"
          role="dialog"
          aria-modal="true"
          aria-label="Menu di navigazione"
          data-testid="mobile-drawer"
          class="absolute inset-y-0 left-0 flex w-68 max-w-full flex-col shadow-lg"
          cdkTrapFocus
          [cdkTrapFocusAutoCapture]="true"
          (keydown.escape)="closed.emit()"
        >
          <ng-content />
        </div>
      </div>
    }
  `,
})
export class MobileDrawerComponent {
  readonly open = input(false);
  readonly closed = output();

  private readonly document = inject(DOCUMENT);
  private opener: HTMLElement | null = null;

  constructor() {
    effect(() => {
      if (this.open()) {
        this.opener = this.document.activeElement as HTMLElement | null;
      } else if (this.opener) {
        // Il fuoco torna al pulsante che ha aperto il pannello.
        const opener = this.opener;
        this.opener = null;
        if (opener.isConnected) {
          opener.focus();
        }
      }
    });
  }
}
